module.exports = __webpack_public_path__ + "img/figure02_sp.4c0cb38a.png";